import { parseResearchScope, type ResearchScopeRef } from "../../shared/wire/research.ts";

/**
 * Where a link sends a person: `/?session=<id>`, `/?loop=<id>`, `/?schedule=<id>`, or the research page at
 * `/research` or `/?research=<project:id|unassigned>&record=<id>`; `&view=map` opens a project's research map.
 */
export type DeepLink = { kind: "session" | "loop" | "schedule"; id: string } | { kind: "research"; scope?: ResearchScopeRef; record?: string; view?: "map" };

export function parseDeepLink(href: string): DeepLink | null {
	let url: URL;
	try {
		url = new URL(href, "http://localhost");
	} catch {
		return null;
	}
	const params = url.searchParams;
	for (const kind of ["session", "loop", "schedule"] as const) {
		const id = params.get(kind)?.trim();
		if (id) return { kind, id };
	}
	const scope = parseResearchScope(params.get("research"));
	if (!scope && url.pathname.replace(/\/+$/, "") !== "/research") return null;
	const record = params.get("record")?.trim();
	const view = scope?.kind === "project" && params.get("view") === "map" ? "map" : undefined;
	return { kind: "research", ...(scope ? { scope } : {}), ...(scope && record ? { record } : {}), ...(view ? { view } : {}) };
}
